import { render, staticRenderFns } from "./UpdateLoyaltyCardForm.vue?vue&type=template&id=9c8286c4&"
import script from "./UpdateLoyaltyCardForm.vue?vue&type=script&lang=js&"
export * from "./UpdateLoyaltyCardForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLoyaltyCardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports